import type { NFTStakingPosition } from "@stepfinance/nft";
import type {
  LockedStakingPosition,
  StakingPosition,
  StarAtlasAtlasLockPosition,
  StarAtlasPolisLockPosition,
} from "@stepfinance/staking";

export type StakingActions<Stake extends StakingPosition> = {
  onClaim?: (stake: Stake) => void;
  onCompound?: (stake: Stake) => void;
};

export type StakingPositions =
  | StakingPosition
  | NFTStakingPosition
  | LockedStakingPosition
  | StarAtlasPolisLockPosition
  | StarAtlasAtlasLockPosition;

export const isNFTStakingPosition = (position: StakingPositions): position is NFTStakingPosition => {
  return typeof (position as NFTStakingPosition).nft.name === "string";
};
export const isLockedStakingPosition = (position: StakingPositions): position is LockedStakingPosition => {
  return typeof (position as LockedStakingPosition).stakeDuration === "number";
};
export const isPolisLockPosition = (position: StakingPositions): position is StarAtlasPolisLockPosition => {
  return typeof (position as StarAtlasPolisLockPosition).multiplier === "number";
};
export const isAtlasLockPosition = (position: StakingPositions): position is StarAtlasAtlasLockPosition => {
  return typeof (position as StarAtlasAtlasLockPosition).marketplaceFee === "number";
};
